// utils/api.js
// Works on web (same-origin) and on Capacitor (absolute URL).

export function getApiBaseUrl() {
  // Configure in env (recommended):
  // NEXT_PUBLIC_API_BASE_URL=https://ilyzlist-io.vercel.app
  const envBase = process.env.NEXT_PUBLIC_API_BASE_URL;

  const isNative =
    typeof window !== "undefined" &&
    !!(window.Capacitor && window.Capacitor.isNativePlatform && window.Capacitor.isNativePlatform());

  if (isNative) return (envBase || "https://ilyzlist-io.vercel.app").replace(/\/$/, "");
  return "";
}

export async function apiFetch(path, options) {
  const base = getApiBaseUrl();
  const normalizedPath = path.startsWith("/") ? path : `/${path}`;
  return fetch(`${base}${normalizedPath}`, options);
}
